export const PRODUCT_ADD_TO_CARD = "PRODUCT_ADD_TO_CARD"
export const PRODUCT_ADD_TO_CARD_DELETE = "PRODUCT_ADD_TO_CARD_DELETE"
export const PRODUCT_ADD_TO_CARD_RESET = "PRODUCT_ADD_TO_CARD_RESET"


